import React from "react";
import PropTypes from "prop-types";
import { ModalWrapper } from "../../../../../shared/widgets";
import HlsVideoPlayer from "../../../../../shared/components/streaming/HlsVideoPlayer";
import styles from "./ViewStream.module.css";
import { fetchCameraLiveFeed, fetchCameraBrands } from "../../../../../services/vehicleMasterService";

const StreamView = ({ showModal, onClose, cameraId: propCameraId, isModal = true, onError, dialogClassName }) => {
    const [cameraId, setCameraId] = React.useState(propCameraId || "");
    const [password, setPassword] = React.useState("");
    const [cameraBrand, setCameraBrand] = React.useState("");
    const [cameraBrands, setCameraBrands] = React.useState([]);
    const [streamUrl, setStreamUrl] = React.useState("");
    const [error, setError] = React.useState("");
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        fetchCameraBrands()
            .then((response) => {
                if (response && Array.isArray(response)) {
                    setCameraBrands(response);
                }
            })
            .catch((err) => {
                console.error("Error fetching camera brands:", err);
            });
    }, []);

    React.useEffect(() => {
        if (propCameraId && (isModal ? showModal : true)) {
            onSubmit(propCameraId);
        }
    }, [propCameraId, showModal, isModal]);

    const onSubmit = (idToSubmit) => {
        const id = idToSubmit || cameraId;
        if (!id.trim()) return;
        setStreamUrl("");
        setError("");
        setLoading(true);
        fetchCameraLiveFeed(id.trim(), password, cameraBrand)
            .then((response) => {
                let result = response?.[0] || null;
                if (result?.status === "SUCCESS") {
                    setStreamUrl(result.hlsUrl);
                    if (onError) onError(false);
                } else if (result?.status === "FAILURE") {
                    const errorMsg = result?.reason || "Failed to fetch stream URL";
                    setError(errorMsg);
                    if (onError) onError(true);
                }
            })
            .catch((err) => {
                console.error("Error fetching stream URL:", err);
                setError("Error fetching stream URL");
                if (onError) onError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const streamContent = (
        <div className={styles.container}>
            {!propCameraId && (
                <div className={styles.formContainer}>
                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="cameraIdInput">Enter Camera Id</label>
                        <input
                            id="cameraIdInput"
                            type="text"
                            className={styles.input}
                            placeholder="Enter Camera Id"
                            value={cameraId}
                            onChange={(e) => setCameraId(e.target.value)}
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="passwordInput">Password (Optional)</label>
                        <input
                            id="passwordInput"
                            type="password"
                            className={styles.input}
                            placeholder="Enter Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className={styles.formGroup}>
                        <label className={styles.label} htmlFor="cameraBrandInput">Camera Brand (Optional)</label>
                        <select
                            id="cameraBrandInput"
                            className={styles.input}
                            value={cameraBrand}
                            onChange={(e) => setCameraBrand(e.target.value)}
                        >
                            <option value="">Select Camera Brand</option>
                            {cameraBrands.map((brand) => (
                                <option key={brand} value={brand}>
                                    {brand}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button
                        className="confirm-btn"
                        onClick={() => onSubmit()}
                        disabled={loading || !cameraId.trim()}
                    >
                        Submit
                    </button>
                </div>
            )}
            {loading && (
                <div className={styles.streamBox}>
                    Loading stream...
                </div>
            )}
            {error && (
                <div className={styles.streamBox}>
                    <i
                        className="fa fa-info me-2"
                        aria-hidden="true"
                    ></i>
                    {error}
                </div>
            )}

            {streamUrl && (
                <>
                    {/* <div className={styles.feedHeading}>Live Feed</div> */}

                    <div className={styles.videoWrapper}>
                        <HlsVideoPlayer
                            src={streamUrl}
                            isModal={isModal}
                            onLiveStatusChange={(isLive) =>
                                console.log("Live status:", isLive)
                            }
                            onError={(hasError, errorMsg) => {
                                if (onError) {
                                    onError(hasError);
                                }
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );

    if (!isModal) {
        return streamContent;
    }

    return (
        <StreamModal
            showModal={showModal}
            onClose={onClose}
            streamContent={streamContent}
            dialogClassName={dialogClassName}
        />
    );
};


const StreamModal = ({ showModal, onClose, streamContent, dialogClassName }) => (
    <ModalWrapper
        showModal={showModal}
        title="Stream View"
        messageCallBack={onClose}
        bodyRender={() => streamContent}
        dialogClassName={dialogClassName}
    />
);

StreamModal.propTypes = {
    showModal: PropTypes.bool,
    onClose: PropTypes.func,
    streamContent: PropTypes.node,
    dialogClassName: PropTypes.string,
};

export default StreamView;


StreamView.propTypes = {
    showModal: PropTypes.bool,
    onClose: PropTypes.func,
    cameraId: PropTypes.string,
    isModal: PropTypes.bool,
    onError: PropTypes.func,
    dialogClassName: PropTypes.string,
};
